<template>
  <v-container fluid grid-list-xl>
    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE DESKTOP      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div v-responsive.lg.xl>
      <div>
        <!--PARTIE NOTRE PLATEFORME -->
        <div class="mt-5 pt-5">
          <div class="container">
            <div>
              <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop">{{ $t('home_page.plateforme_section_title') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
            </div>
            <div class="mt-3 row">
              <div class="col-lg-12 text-center">
                <div class="container_plateforme">
                  <div class="servcies-section-wrapper">
                    <div class="services-box">
                      <img   src="../../assets/img/home/new_home/platform_section/subscription.png" alt="subscription" width="10%">
                      <h3>{{ $t('home_page.product_plateforme_section_title') }}</h3>
                      <div style="height: 100px;">
                        <p>{{ $t('home_page.product_plateforme_section_content') }}.</p>
                        <span style="color: #ffa409;font-weight: 500;float: right;margin-right: 3%" @click="goToContactForm('product')">{{ $t('contact.en_savoir_label') }}</span>
                      </div>
                    </div>
                    <div class="services-box">
                      <img   src="../../assets/img/home/new_home/platform_section/product.png" alt="product" width="10%">
                      <h3>{{ $t('home_page.souscription_plateforme_section_title') }}</h3>
                      <div style="height: 100px;">
                        <p>{{ $t('home_page.souscription_plateforme_section_content') }}.</p>
                        <span style="color: #ffa409;font-weight: 500;float: right;margin-right: 3%;" @click="goToContactForm('souscription')">{{ $t('contact.en_savoir_label') }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container_plateforme pt-4">
                  <div class="servcies-section-wrapper">
                    <div class="services-box">
                      <img   src="../../assets/img/home/new_home/platform_section/data.png" alt="data" width="10%">
                      <h3>{{ $t('home_page.pilotage_plateforme_section_title') }}</h3>
                      <div style="height: 100px;">
                        <p>{{ $t('home_page.pilotage_plateforme_section_content') }}.</p>
                        <span style="color: #ffa409;font-weight: 500;float: right;margin-right: 3%;" @click="goToContactForm('pilotage')">{{ $t('contact.en_savoir_label') }}</span>
                      </div>
                    </div>
                    <div class="services-box" style="background-color: #ffa409">
                      <img   src="../../assets/img/home/new_home/platform_section/api.png" alt="api" width="10%">
                      <h3>{{ $t('home_page.innovation_plateforme_section_title') }}</h3>
                      <div style="height: 100px;">
                        <p>{{ $t('home_page.innovation_plateforme_section_content') }}.</p>
                        <span style="color: #fff;font-weight: 500;float: right;margin-right: 3%;margin-top: -4%;" @click="goToContactForm('innovation')">{{ $t('contact.en_savoir_label') }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ===================    DEBUT DE LA PARTIE UNIQUEMENT POUR LE MOBILE      =============== -->
    <!-- =                      SACHANT QUE LE CODE EST ASSEZ LONG, IL CONVIENT                  = -->
    <!-- =                      DE BIEN INDENTER LE CODE POUR UNE BONNE LISIBILITE               = -->
    <!-- ========================================================================================= -->
    <div style="margin-top:50px" v-responsive.sm.xs>
      <div>
        <!--PARTIE NOTRE PLATEFORME -->
        <div class="mt-5">
          <div class="container">
            <div>
              <div class="justify-content-center row">
              <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('home_page.plateforme_section_title') }}</h1>
            </div>
            <div class="justify-content-center row">
              <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
            </div>
            </div>
            <div class="mt-3 row">
              <div class="col-lg-12 text-center">
                <div class="container_plateforme_mobile">
                  <div class="servcies-section-wrapper_mobile">
                    <div class="services-box_mobile">
                      <img   src="../../assets/img/home/new_home/platform_section/subscription.png" alt="subscription" width="10%">
                      <h3>{{ $t('home_page.product_plateforme_section_title') }}</h3>
                      <div style="margin-top: -40px;margin-bottom: 5px;">
                        <p>{{ $t('home_page.product_plateforme_section_content') }}. <br> <span class="mb-2" style="color:#ffa409;font-weight: 500;float: right;" @click="goToContactForm('product')">{{ $t('contact.en_savoir_label') }}</span></p>
                      </div>
                    </div>
                    <div class="services-box_mobile">
                      <img   src="../../assets/img/home/new_home/platform_section/product.png" alt="product" width="10%">
                      <h3>{{ $t('home_page.souscription_plateforme_section_title') }}</h3>
                      <div style="margin-bottom: 5px;margin-top: -40px;">
                        <p>{{ $t('home_page.souscription_plateforme_section_content') }}. <br> <span class="mb-2" style="color:#ffa409;font-weight: 500;float: right;" @click="goToContactForm('souscription')">{{ $t('contact.en_savoir_label') }}</span></p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="container_plateforme_mobile pt-4">
                  <div class="servcies-section-wrapper_mobile">
                    <div class="services-box_mobile">
                      <img   src="../../assets/img/home/new_home/platform_section/data.png" alt="data" width="10%">
                      <h3>{{ $t('home_page.pilotage_plateforme_section_title') }}</h3>
                      <div style="margin-bottom: 5px;margin-top: -40px;">
                        <p>{{ $t('home_page.pilotage_plateforme_section_content') }}. <br> <span class="mb-2" style="color:#ffa409;font-weight: 500;float: right;" @click="goToContactForm('pilotage')">{{ $t('contact.en_savoir_label') }}</span></p>
                      </div>
                    </div>
                    <div class="services-box_mobile" style="background-color: #ffa409">
                      <img   src="../../assets/img/home/new_home/platform_section/api.png" alt="api" width="10%">
                      <h3>{{ $t('home_page.innovation_plateforme_section_title') }}</h3>
                      <div style="margin-bottom: 5px;margin-top: -40px;">
                        <p>{{ $t('home_page.innovation_plateforme_section_content') }}. <br> <span class="mb-2" style="color:#fff;font-weight: 500;float: right;" @click="goToContactForm('innovation')">{{ $t('contact.en_savoir_label') }}</span></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
export default {
  name: 'plateforme_section',
  components: {
    simplebar

  },
  data: () => ({
    title: 'Assuraf',
    description: 'Le meilleur de l\'assurance en ligne au Sénégal. Faites votre devis, souscrivez et payez en ligne: vous êtes assuré ! Un service simple, une offre claire et complète, une expérience proactive et multicanale.',
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        charset: 'utf-8'
      },
        {
          name: 'description',
          content: this.description
        }
      ]
    }
  },

  methods: {
    goToContactForm (item) {
      console.log("item==== ", item)
      let url = "/contactform/"
      url += item;
      this.$router.push({ path: url,})  
    }
  },

  mounted() {
  window.scrollTo(0, 0);  
  }
}
</script>

<style lang="less" scoped>

@import "../../assets/less/config";
@import "../../assets/css/button.css";
@import "../../assets/css/plateforme-home-section.css";

@keyframes header-animation {
  from {
    transform: translate3d(0, -100%, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}


.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
}

.titre_for_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}

.newsletter_titre_desktop {
  color: #2b2b2b;
  font-size: 25px;
  font-weight: bold;
  margin-top: 6%;
  text-align: center;
}

.margin {
  margin-left: 8%;
  margin-right: 8%;
}

.margin_mobile {
  margin-left: 5%;
  margin-right: 5%;
}

.margin-titre {
  margin-top: 48px;
  padding-bottom: 48px;
}

a, button {
  outline: none;
  cursor: pointer;
}

img {
  max-width: 100%;
}

h1 {
  font-weight: 100;
  font-size: 58px;
}

h2 {
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
}

h3 {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 40px;
}

h1, h2 {
  margin: 0 0 20px;
  color: #fff;
}

p {
  font-size: 14px;
}




.text-lg-left {
  text-align: left !important;
}

.col-text {
  height: 20em;
}


.col {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.col-left {
  -webkit-box-ordinal-group: -1;
  -webkit-order: -1;
  -ms-flex-order: -1;
  order: -1;
}

.col-text {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Aligner-item {
  width: 70%;
  font-size: 20px
}



.container_plateforme {
width: 100%;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
margin: 25px 0px;
}

.servcies-section-wrapper {
//width: 60%;
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 45px;
}

.services-box {
box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
//background-color: #a9a7a7;
color: white;
width: 45%;
padding: 5px 5px;
border-radius: 12px;
display: flex;
justify-content: center;
flex-direction: column;
//align-items: center;
//gap: 10px;
transition: all 0.3s ease-in-out;
}

.services-box:hover {
i {
  margin-left: 10px;
}
transition: all 0.4s ease-out;
background-color: #ffa409;
//font-weight:400;
span {
  color: #fff!important;
  cursor: pointer;
}
}

.services-box h3 {
//font-size: 15px;
margin-top: -10px;
margin-bottom: 0;
margin-left: 10px;
text-align: start;
color: #2b2b2b;
text-transform: none;
}

.services-box p {
margin: 10px;
text-align: start;
color: #2b2b2b;
font-size: 15px!important;
}

.services-box i {
background-color: white;
color: #ffa409;
width: 60px;
height: 60px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 40px;
margin-bottom: 16px;
margin-top: 16px;
font-size: 24px;
}







.container_plateforme {
width: 100%;
height: auto;
display: flex;
flex-direction: column;
align-items: center;
margin: 25px 0px;
}

.servcies-section-wrapper {
//width: 60%;
display: flex;
justify-content: center;
flex-wrap: wrap;
gap: 45px;
}

.services-box {
box-shadow: rgba(0, 0, 0, 0.2) 0px 18px 50px -10px;
//background-color: #a9a7a7;
color: white;
width: 45%;
padding: 5px 5px;
border-radius: 12px;
display: flex;
justify-content: center;
flex-direction: column;
//align-items: center;
//gap: 10px;
transition: all 0.3s ease-in-out;
}

.services-box:hover {
i {
  margin-left: 10px;
}
transition: all 0.4s ease-out;
background-color: #ffa409;
//font-weight:400;
}

.services-box h3 {
//font-size: 15px;
margin-top: -10px;
margin-bottom: 0;
margin-left: 10px;
text-align: start;
color: #2b2b2b;
text-transform: none;
}

.services-box p {
margin: 10px;
text-align: start;
color: #2b2b2b;
font-size: 15px!important;
}

.services-box i {
background-color: white;
color: #ffa409;
width: 60px;
height: 60px;
display: flex;
justify-content: center;
align-items: center;
border-radius: 40px;
margin-bottom: 16px;
margin-top: 16px;
font-size: 24px;
}
</style>

